import { useState } from 'react';

export const useSmsCode = () => {
    const [smsCode, setSmsCode] = useState('');

    const isCodeSet = smsCode?.length > 5;

    return { smsCode, isCodeSet, setSmsCode };
};
